import { render, staticRenderFns } from "./PassCard.vue?vue&type=template&id=606437f0&scoped=true"
import script from "./PassCard.vue?vue&type=script&lang=js"
export * from "./PassCard.vue?vue&type=script&lang=js"
import style0 from "./PassCard.vue?vue&type=style&index=0&id=606437f0&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606437f0",
  null
  
)

export default component.exports